import { useLoaderData } from '@remix-run/react';
import type { FC } from 'react';
import { slugify } from '~/lib/slugify';
import type { loader } from '../_index';

interface Service {
  title: string;
  imageSrc: string;
}

const BlogSidebar: FC = () => {
  const { blogPosts } = useLoaderData<typeof loader>();

  return (
    <aside className="space-y-6">
      <h2 className="text-xl font-bold font-lato text-right text-[#4b4e53] mb-4">HİZMETLERİMİZ</h2>
      <div className="space-y-4">
        {blogPosts.map((post) => (
          <a key={post.title} href={`/blog/${slugify(post.title)}`} className="flex items-center space-x-2 justify-center">
            <strong className="flex w-9/12 text-sm text-right justify-end uppercase font-normal font-lato text-[#4b4e53]">{post.title}</strong>
            <img
              src={post.image}
              alt={post.title}
              className="w-3/12 object-cover"
            />
          </a>
        ))}
      </div>
    </aside>
  );
};

export default BlogSidebar;